import React, { useContext, useState } from 'react';
import { GameLog } from '../../../../Logs/LogsDisplay';
import GameAssetsContext from '../../../../../../context/GameAssetContext';
import './KeyPressInterruptEvent.css';

interface KeyPressInterruptEventProps {
  interruptEvent: GameLog;
  spellImageUrls: Record<string, string>;
  championName: string;
}

const KeyPressInterruptEvent: React.FC<KeyPressInterruptEventProps> = ({
  interruptEvent,
  spellImageUrls,
  championName,
}) => {
  const { gameWideAssets } = useContext(GameAssetsContext);
  const [showTooltip, setShowTooltip] = useState(false);

  const abilityKey = interruptEvent.details.abilityKey?.toLowerCase();
  const duration = interruptEvent.details.duration ? (interruptEvent.details.duration / 1000).toFixed(1) : '0.0';
  
  // Get ability icon URL
  const abilityIconUrl = abilityKey ? spellImageUrls[abilityKey.toUpperCase()] : undefined;

  return (
    <div 
      className="keypress-interrupt-event"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {/* Main ability icon area - matching KeyPressLog structure */}
      <div className="ability-container-wrapper">
        <div className="ability-image-container">
          {abilityIconUrl ? (
            <img 
              src={abilityIconUrl} 
              alt={`${abilityKey?.toUpperCase()} interrupted`}
              className="ability-img interrupted"
            />
          ) : (
            <div className="ability-img fallback-icon interrupted">
              {abilityKey?.toUpperCase() || '?'}
            </div>
          )}
          
          {/* Stop overlay - positioned at top right */}
          <div className="stop-overlay-circle">
            <div className="stop-symbol">⊘</div>
          </div>
          
          {/* Ability letter - positioned at bottom right */}
          {abilityKey && <div className="ability-letter">{abilityKey.toUpperCase()}</div>}
        </div>
      </div>

      {/* Duration box below - matching TotalDamage structure */}
      <div className="duration-container">
        <div className="duration-value">
          <div className="duration-time">{duration}s</div>
          <div className="duration-label">Duration</div>
        </div>
      </div>

      {/* Tooltip */}
      {showTooltip && (
        <div className="interrupt-tooltip">
          <div className="tooltip-title">Toggle Deactivated</div>
          <div className="tooltip-details">
            {championName} deactivated {abilityKey?.toUpperCase()} after {duration} seconds
          </div>
        </div>
      )}
    </div>
  );
};

export default KeyPressInterruptEvent; 